import { defineStore } from 'pinia'
import { Meta } from '@/models'
import { ref } from 'vue'
import { PaginationProps } from 'naive-ui'
import { API } from '@/api/api'

export const useGrupos = defineStore({
  id: 'grupos',
  state: () => ({
    data: <any>[],
    meta: <Meta>{},
    order: 'desc',
    pagination: ref<PaginationProps>({
      page: 1,
      showSizePicker: true,
      pageCount: 1,
      pageSize: 20,
      pageSizes: [5, 10, 20, 40, 60, 100],
    }),
    isLoading: false,
    error: null as unknown,
  }),
  actions: {
    async fetch(all = false) {
      try {
        this.isLoading = true
        this.error = null
        let response
        if (!all) {
          response = await API().get(
            `dashboard/grupos?page=${this.pagination.page}&order=${this.order}&perPage=${this.pagination.pageSize}`
          )
          this.data = response.data.data.map((file: any) => file)
          this.meta = response.data.metameta as Meta
        } else {
          response = await API().get(`dashboard/grupos?all=true`)
          this.data = response.data.map((file: any) => file)
        }
        await this.updatePagination()
      } catch (error) {
        this.error = error
      } finally {
        this.isLoading = false
      }
    },
    updatePagination() {
      this.pagination = {
        ...this.pagination,
        page: this.meta.current_page,
        pageCount: this.meta.last_page,
        pageSize: this.meta.per_page,
      }
    },
    handlePageSizeChange(pageSize: number) {
      this.pagination = {
        ...this.pagination,
        pageSize,
        page: 1,
      }
      if (!this.isLoading) {
        this.fetch()
      }
    },
    handlePageChange(currentPage: number) {
      this.pagination = {
        ...this.pagination,
        page: currentPage,
      }
      console.log(this.pagination)
      if (!this.isLoading) {
        this.fetch()
      }
    },
    clearError() {
      this.error = null
    },
  },
})
